var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('h1',[_vm._v("Received History")]),_c('operator-table',{attrs:{"orders":_vm.orders,"pagination":_vm.pagination,"headers":_vm.headers},on:{"getData":_vm.getWalkingReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }